import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';

const CesPricesStyles = css`
  .ces-prices-container {
    display: block;
  }

  .ces-badges-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
  }

  .ces-badge {
    height: 16px;
    border-radius: 0 0 0 4px;
    color: ${colors.white.shade1};
    font-size: ${typography.xs2};
    font-weight: 800;
    line-height: 16px;
    padding: 0 4px;
    background-color: ${colors.black.shade3};
  }

  .ces-badge-ces_black {
    background-color: ${colors.black.shade3};
    width: 66px;
  }

  .ces-badge-ces_oro {
    background: var(
      --oro,
      linear-gradient(
        280deg,
        ${colors.golden.shade1} 25.37%,
        ${colors.golden.shade2} 81.71%,
        ${colors.golden.shade3} 112.31%
      )
    );
    background-blend-mode: darken;
    width: 56px;
  }

  .ces-badge-ces_plata {
    width: 65px;
    background: linear-gradient(
      95deg,
      ${colors.silver.shade1} 7.86%,
      ${colors.silver.shade2} 47.08%,
      ${colors.silver.shade3} 61.58%
    );
    background-blend-mode: darken;
    color: ${colors.black.shade3};
  }

  .ces-discount-badge {
    height: 16px;
    background-color: ${colors.black.shade3};
    width: auto;
    border-radius: 0 4px 0 0;
    color: ${colors.white.shade1};
    font-size: ${typography.xs2};
    font-weight: 800;
    line-height: 16px;
    padding: 0 4px;
  }

  .ces-discount-badge-ces_black {
    background-color: ${colors.black.shade3};
  }

  .ces-discount-badge-ces_oro {
    background-color: ${colors.orange.shade5};
  }

  .ces-discount-badge-ces_plata {
    background-color: ${colors.gray.shade62};
    color: ${colors.black.shade3};
  }

  .ces-unit-price-normal {
    font-size: ${typography.base};
    text-decoration: line-through;
    font-weight: 400;
    color: ${colors.gray.shade52};
    line-height: normal;
    margin-left: 2px;
  }

  .ces-unit-price-ces {
    font-size: ${typography.xl};
    font-weight: 400;
    color: ${colors.gray.shade52};
    line-height: normal;
    margin-top: 2px;
  }
`;

export { CesPricesStyles };
